import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Jcb = function Jcb(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#JCB_svg__JCB_svg__clip0_20336_109077)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.044 22.377v-1.868h2.043a1 1 0 01.253.02c.39.096.72.447.72.914 0 .486-.33.837-.72.915-.058 0-.195.019-.253.019h-2.043zm1.81-12.902h5.176v17.69a3.542 3.542 0 01-3.542 3.541h-5.196v-7.2h5.488c1.285 0 2.258-.7 2.258-1.771 0-.993-.876-1.635-2.024-1.713v-.039c1.05-.136 1.615-.817 1.615-1.615 0-1.012-.837-1.596-1.966-1.654-.097-.02-.233-.02-.35-.02h-5.001v-3.678a3.542 3.542 0 013.541-3.541zm.953 9.127c0 .467-.33.778-.72.836-.02.02-.136.02-.195.02h-1.848v-1.713h1.848c.059 0 .156.02.195.02.39.058.72.37.72.837z",
    fill: "url(#JCB_svg__JCB_svg__paint0_linear_20336_109077)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.065 9.475a3.542 3.542 0 00-3.542 3.541v4.632c.895-.759 2.452-1.245 4.963-1.129 1.342.059 2.782.429 2.782.429v1.498c-.72-.37-1.576-.7-2.685-.779-1.907-.136-3.055.798-3.055 2.433 0 1.654 1.148 2.588 3.055 2.433 1.11-.078 1.966-.428 2.686-.779v1.499s-1.421.37-2.783.428c-2.51.117-4.068-.37-4.963-1.129v8.174h5.196a3.542 3.542 0 003.542-3.542V9.474h-5.196z",
    fill: "url(#JCB_svg__JCB_svg__paint1_linear_20336_109077)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.276 9.475a3.542 3.542 0 00-3.541 3.541v8.738c.992.487 2.023.798 3.055.798 1.226 0 1.888-.74 1.888-1.751v-4.126h3.035v4.106c0 1.596-.992 2.9-4.359 2.9a14.94 14.94 0 01-3.639-.448v7.454h5.196a3.542 3.542 0 003.542-3.542V9.475H9.276z",
    fill: "url(#JCB_svg__JCB_svg__paint2_linear_20336_109077)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCB_svg__JCB_svg__paint0_linear_20336_109077",
    x1: 25.308,
    y1: 30.707,
    x2: 34.054,
    y2: 30.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCB_svg__JCB_svg__paint1_linear_20336_109077",
    x1: 15.473,
    y1: 30.57,
    x2: 24.098,
    y2: 30.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCB_svg__JCB_svg__paint2_linear_20336_109077",
    x1: 5.73,
    y1: 30.861,
    x2: 14.611,
    y2: 30.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "JCB_svg__JCB_svg__clip0_20336_109077"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
export default Jcb;